type MainTitleProps = {
    subtitle?: string;
}

export default function MainTitle({subtitle} : MainTitleProps) {

    if (!subtitle) {
        subtitle = '';
    }

    return (
        <>
            <div>
                <h1 className="mainTitle">
                    alphabet<br/><span className="mainTitleWord2">soup.</span>
                </h1>
                {subtitle &&
                    <div className='subtitle'>
                        {subtitle}
                    </div>
                }
            </div>      
        </>
    )
    
}